import { type SerializableStateInvariantMiddlewareOptions } from '@reduxjs/toolkit';

import { UploadStatus } from './types';

// biome-ignore lint/style/noMagicNumbers: 25 MiB chunk size for multipart uploads
export const CHUNK_SIZE = 25 * 1024 * 1024;

/**
 * RTK serializableCheck overrides for the uploader slice.
 * Upload state intentionally holds File, XMLHttpRequest, and abort callbacks.
 */
export const UPLOADER_SERIALIZABLE_CHECK: SerializableStateInvariantMiddlewareOptions = {
  ignoredActionPaths: ['payload.uploads', 'payload.xhr', 'payload.abort'],
  ignoredPaths: ['uploader.uploadsArray', 'uploader.uploadProgress'],
};

export const activeUploadStates = [
  UploadStatus.uploading,
  UploadStatus.queued,
  UploadStatus.paused,
  UploadStatus.preparing,
];

export const pausableStates = [UploadStatus.uploading, UploadStatus.queued, UploadStatus.preparing];
